import { useEffect, useRef } from "react";
import { Dialogo, Fundo } from "./styled";
import ContadorMinimo from "../../../components/ContadorMinimo";

/**
 * Diálogo de decisão de um pedido (perfil Profissional ou apoiador): aprovar com
 * mensagem opcional / recusar com motivo obrigatório. `avisoAprovacao` diz o que a
 * aprovação faz (muda por tipo de pedido). Foco no campo ao abrir, Esc fecha, clique fora fecha.
 * Numa tabela de grade única não cabe um formulário dentro da linha, por isso o
 * painel de decisão é um diálogo.
 */
export default function DecisaoDialogo({ pedido, acao, resposta, setResposta, erro, enviando, minimoMotivo = 3, avisoAprovacao, onConfirmar, onCancelar }) {
  const campo = useRef(null);
  const recusando = acao === "recusar";
  // Desabilitar/habilitar o apoio: so confirmacao (sem mensagem para a pessoa).
  const alternando = acao === "desabilitar" || acao === "habilitar";
  const nome = pedido.usuario?.nome || "a pessoa";

  const botao = useRef(null);
  useEffect(() => { (alternando ? botao : campo).current?.focus(); }, [alternando]);

  useEffect(() => {
    const aoTeclar = (e) => { if (e.key === "Escape") onCancelar(); };
    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [onCancelar]);

  return (
    <Fundo onMouseDown={(e) => { if (e.target === e.currentTarget) onCancelar(); }}>
      <Dialogo role="dialog" aria-modal="true" aria-labelledby="decisao-titulo">
        <h3 id="decisao-titulo">
          {acao === "desabilitar" ? `Desabilitar o apoio de ${nome}?`
            : acao === "habilitar" ? `Habilitar o apoio de ${nome}?`
            : recusando ? `Recusar o pedido de ${nome}` : `Aprovar o pedido de ${nome}`}
        </h3>
        {acao === "desabilitar" && <p className="aviso">Ele deixa de aparecer no site e no app. Você pode habilitar de novo.</p>}
        {acao === "habilitar" && <p className="aviso">O apoio volta a aparecer no site e no app.</p>}
        {!recusando && !alternando &&
          <p className="aviso">{avisoAprovacao || `Ao aprovar, ${nome} passa a ter o perfil Profissional na hora.`}</p>
        }

        {!alternando && <>
          <label htmlFor="decisao-resposta">
            {recusando ? "Motivo da recusa (obrigatório)" : "Mensagem para a pessoa (opcional)"}
          </label>
          <textarea
            id="decisao-resposta" ref={campo} maxLength={1000} value={resposta}
            placeholder={recusando ? "Explique o que faltou para que a pessoa possa pedir de novo." : "Ex.: Bem-vindo! Qualquer dúvida, é só chamar."}
            onChange={(e) => setResposta(e.target.value)}
          />
          {recusando && <ContadorMinimo valor={resposta.trim()} minimo={minimoMotivo} campo="O motivo" />}
        </>}
        {erro && <span className="erro" role="alert">{erro}</span>}

        <div className="botoes">
          <button type="button" className="cancelar" onClick={onCancelar}>Cancelar</button>
          <button type="button" ref={botao} className={recusando || acao === "desabilitar" ? "recusar" : ""} disabled={enviando} onClick={onConfirmar}>
            {acao === "desabilitar" ? "Desabilitar" : acao === "habilitar" ? "Habilitar" : recusando ? "Confirmar recusa" : "Confirmar aprovação"}
          </button>
        </div>
      </Dialogo>
    </Fundo>
  );
}
